import Alma from '../../../icons/Alma';
import Chat from '../../../icons/Chat';
import { Config } from '../../../../config';
import React from 'react';

const Trigger = ({ hasBot, showBot, handleToggle }) => {
  function hideChat() {
    document.getElementById('chatControl').classList.toggle('chat--hide');
  }
  return (
    <button
      className="chatbot_trigger"
      data-active={ hasBot }
      onClick={() => { handleToggle(); hideChat();} }
    >
      { showBot ? 'Close' : 'Open'} { Config.chatbot.name }
      <Chat />
      <Alma />
    </button>
  )
};

export default Trigger;
